export default __webpack_public_path__ + "static/media/56.1e6aa504.jpg";